var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.91,
    height: 27.91,
    viewBox: "0 0 27.91 27.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M550.913,530.664H553.7v-2.791h-2.791Zm1.4-22.328a13.955,13.955,0,1,0,13.955,13.955A13.96,13.96,0,0,0,552.308,508.336Zm0,25.119a11.164,11.164,0,1,1,11.164-11.164A11.179,11.179,0,0,1,552.308,533.455Zm0-19.537a5.581,5.581,0,0,0-5.582,5.582h2.791a2.791,2.791,0,0,1,5.582,0c0,2.791-4.187,2.442-4.187,6.978H553.7c0-3.14,4.187-3.489,4.187-6.978A5.581,5.581,0,0,0,552.308,513.918Z",
    transform: "translate(-538.353 -508.336)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.071e27b0b999f2c7340dcb544657925f.svg";
export { ForwardRef as ReactComponent };